const serverApi = {
  user_refresh: "/user/refresh",
  user_login: "/user/login",
  user_identity: "/user/"
}
export default serverApi;
